import { all, call, put, select, take, takeEvery } from 'redux-saga/effects';
import { putJSON } from '../../util';

export function* login({ payload }) {
    try {
        yield call(putJSON, '/api/user/login', payload);
    } catch (e) {
        if (e.body.error_code == 'member not found') {
            yield all([
                put({
                    type: 'user:update',
                    payload: {
                        email: payload.email,
                        password: payload.password,
                    },
                }),
                put({
                    type: 'route:to',
                    payload: 'signup',
                }),
            ]);
        } else if (e.body.error_code == 'invalid password') {
            yield put({
                type: 'user:update',
                payload: {
                    passwordError: true,
                },
            });
        } else if (e.body.error_code == 'member disabled' || e.body.error == 'member disabled') {
            yield put({
                type: 'user:update',
                payload: {
                    passwordError: `The account associated with this email address account has been deleted.
                        Please contact support@tarot.com for further assistance.`,
                },
            });
        } else {
            yield put({
                type: 'route:to',
                payload: '',
            });
        }
    }

    yield put({ type: 'user:refresh' });

    const { payload: user } = yield take('user:update');

    if (user && user.logged_in) {
        const pending = yield select(state => state.product.pending);
        if (pending) {
            yield put({
                type: 'product:update',
                payload: {
                    pending: false,
                },
            });
        }

        yield put({
            type: 'user:logged-in',
            payload: user,
        });

        const route = yield select(state => state.route);

        if (route === 'login' || route === 'signup' || route === 'login-signup') {
            yield put({
                type: 'route:to',
                payload: '',
            });
        }
    }
}

export function* loggedIn() {
    const path = window.location.pathname;

    if (path.match(/^\/forums\//)) {
        let user = yield select(state => state.user);
        let forums_url = yield select(state => state.forums.host);

        if ('forum_name' in user && user.forum_name) {
            yield put({ type: 'location:href', payload: forums_url });
        } else {
            yield put({ type: 'location:href', payload: '/forums/register' });
        }
    }
}

export function* logout() {
    yield put({ type: 'user:logged-out' });
}

export function* loggedOut() {
    const path = window.location.pathname;

    if (path === '/checkout') {
        yield put({ type: 'location:href', payload: '/readings-reports' });
    } else if (path.match(/^\/member\//)) {
        yield put({ type: 'location:href', payload: '/' });
    }
}

export function* root() {
    yield all([
        takeEvery('user:login', login),
        takeEvery('user:logout', logout),
        takeEvery('user:logged-in', loggedIn),
        takeEvery('user:logged-out', loggedOut),
    ]);
}
